import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { saveConfig, saveOptionColor, updateSelectedOptions } from '../../FilterActions';
import { CustomMultiselect, withColorRenderer } from '../common';

class LocalCustomField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      selectedItems: []
    };
  }

  componentDidMount() {
    this.updateState();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.items != this.props.items) {
      this.setState({
        items: this.props.items
      });
    }

    if (prevProps.selectedItems != this.props.selectedItems) {
      this.setState({
        selectedItems: this.props.selectedItems
      });
    }
  }

  updateState() {
    this.setState({
      items: this.props.items,
      selectedItems: this.props.selectedItems
    });
  }

  handleColorChange = e => {
    this.props.saveOptionColor(this.props.id, e.optId, e.color);
  };

  handleChange = selected => {
    this.props.updateSelectedOptions(this.props.id, selected);
    this.props.saveConfig();
  };

  render() {
    const { items, selectedItems } = this.state;
    // this.props.enabledColors === this.props.id; //
    const colorsEnabled =
      this.props.chart !== 'ctb' && this.props.chart !== 'trc'
        ? this.props.enabledColors === this.props.id
        : this.props.enabledColorsLocal === this.props.id;

    return (
      <CustomMultiselect
        name={this.props.name}
        items={items}
        selectedItems={selectedItems}
        onSelect={this.handleChange}
        fieldId={this.props.id}
        colorsChangable={this.props.app !== 'trello' && this.props.app !== 'asana'}
        itemRenderer={colorsEnabled ? withColorRenderer : null}
        onColorChange={this.handleColorChange}
      />
    );
  }
}

LocalCustomField.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    saveConfig: () => dispatch(saveConfig()),
    updateSelectedOptions: (id, vals) => dispatch(updateSelectedOptions(id, vals, null, true)),
    saveOptionColor: (fieldId, optId, color) => dispatch(saveOptionColor(fieldId, optId, color))
  };
};

const mapStateToProps = (state, ownProps) => {
  let chart = state.filters.chart;
  return {
    app: state.app.app,
    enabledColors: state.filters.enabledColors,
    items: state.filters[`all${ownProps.id}`],
    chart: state.filters.chart,
    selectedItems: state.filters[chart][`selected${ownProps.id}`],
    enabledColorsLocal: state.filters[chart].enabledColors
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(LocalCustomField);
export { connected as LocalCustomField };
